const fields = `
id
heading
slug
imageGradient
showMenu
showMobileBanner
headerImage {
  id
  url:url(imgixParams: { auto: compress})
}
mainImage {
  id
  mobileImage: url(imgixParams: {fm: jpg, fit: crop, crop: [faces,edges], w: 750, h: 800, auto: compress})
  responsiveImage(imgixParams: {fm: jpg, fit: crop,crop: [faces,edges], w: 600, auto: compress}){
    srcSet
    sizes
    src
  }
}
headerCta {
  ... on CtaBlockRecord {
    buttonText
    url
  }
}
sections {
  heading
  background
  width
  sectionBlocks {
    __typename
    ... on TextBlockRecord {
      id
      bodyCopy
      centeredText
    }
    ... on ImageBlockRecord {
      image {
        id
        responsiveImage(imgixParams: {fit:crop, w: 986, auto: compress}) {
          alt
          title
          srcSet
          width
          height
        }
      }
      roundedCorners
      caption
    }
    ... on ListPageBlockRecord {
      id
      listItems {
        id
        image {
          id
          url:url(imgixParams: {fit:crop, w: 120, auto: compress})
        }
        heading
        body
      }
    }
    ... on ImageTextBlockRecord {
      id
      text
      image {
        url:url(imgixParams: {fit:crop, w: 484, auto: compress})
        width
        height
      }
      textAlignment
      roundedCorners
    }
    ... on CardBlockRecord {
      id
      heading
      body
      cta
      ctaLink
      image {
        url:url(imgixParams: {fit:crop, w: 484, auto: compress})
        width
        height
      }
    }
    ... on CardsBlockRecord {
      id
      displayAsCards
      cards {
        id
        heading
        image {
          id
          url(imgixParams: {fit:crop, fm: jpg, h: 284})
          width
          height
        }
        body
      }
    }
    ... on CtaBlockRecord {
        buttonText
        url
    }
    ... on SlideshowBlockRecord {
      id
      slides {
        id
        heading
        image{
          url(imgixParams: {fit:crop, w: 782, auto: compress})
        }
        body
      }
    }
    ... on AppButtonBlockRecord {
      appButtons {
        buttonText
        color
        useOfficialButton
      }
    }
    ... on TextHeroRecord {
      heading
      body
      backgroundImage {
        mobileImage: url(imgixParams: {fm: jpg, auto: compress, rot: 90})
        responsiveImage(imgixParams: {fm: jpg, fit: crop,crop: [faces,edges], w: 600, auto: compress}){
          srcSet
          sizes
          src
        }
      }
      image {
        url(imgixParams: {fit:crop, crop: [faces, edges] auto: compress})
        height
        width
      }
      mobileImage {
        url(imgixParams: {fit:crop, crop: [faces, edges] auto: compress})
        height
        width
      }
      imageGradient
      textColor
    }
    ... on NumberedCardsBlockRecord {
      id
      cards {
        id
        heading
        image {
          id
          url(imgixParams: {fit: crop, fm: jpg})
          width
          height
        }
        body
      }
    }
    ... on VideoBlockRecord {
      id
      videos {
        embeddedMedia {
          id: providerUid
          url
          height
          width
        }
      }
    }
  }
}
`

const query = ({ slug, locale = 'en' }) => {
  locale = locale === 'pt' ? 'pt_BR' : locale

  return `
  {
    page: landingPage(filter: {slug: {eq: "${slug}"}}, locale: ${locale}) {
      ${fields}
    },
    fallback: landingPage(filter: {slug: {eq: "${slug}"}}, locale: en) {
      ${fields}
    }
  } 
  `
}

const queryAll = () => `
{
  pages: allLandingPages {
    ${fields}
  }
} 
`

module.exports = {
  query,
  queryAll,
}
